import { CryptographyEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

const cryptographyEngineConfigs: CryptographyEngineConfigs = {
	hashkey: '',
};

export default cryptographyEngineConfigs;
